import { render, staticRenderFns } from "./fastClothes.vue?vue&type=template&id=7c8be976&scoped=true"
import script from "./fastClothes.vue?vue&type=script&lang=js"
export * from "./fastClothes.vue?vue&type=script&lang=js"
import style0 from "./fastClothes.vue?vue&type=style&index=0&id=7c8be976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8be976",
  null
  
)

export default component.exports